import { createContext } from "react";

const PopUp_Context = createContext();

export default PopUp_Context;